import { IPersonalInfo, ConfigField } from '../../../../../types';
import { ApplicationState } from '../../../../../store';

type Fields = Pick<
  IPersonalInfo,
  | 'hasEnglishTest'
  | 'englishTestType'
  | 'englishTestTypeOther'
  | 'englishTestNotReqdReason'
  | 'englishTestNotReqdReasonOther'
  | 'qualification'
  | 'qualificationOther'
>;

type Visible = Record<
  | 'hasEnglishTest'
  | 'englishTestType'
  | 'englishTestTypeOther'
  | 'englishTestNotReqdReason'
  | 'englishTestNotReqdReasonOther'
  | 'qualification'
  | 'qualificationOther',
  boolean
>;

export function getPageStatus(
  config: ApplicationState['config'],
  fields: Fields
): {
  complete: boolean;
  visible: Visible;
} {
  const {
    hasEnglishTest,
    englishTestType,
    englishTestTypeOther,
    englishTestNotReqdReason,
    englishTestNotReqdReasonOther,
    qualification,
    qualificationOther
  } = fields;
  const {
    HasEnglishTest: hasEnglishTestConfig,
    EnglishTestType: englishTestTypeConfig,
    EnglishTestTypeOther: englishTestTypeOtherConfig,
    EnglishTestNotReqdReason: englishTestNotReqdReasonConfig,
    EnglishTestNotReqdReasonOther: englishTestNotReqdReasonOtherConfig,
    Qualification: qualificationConfig
  }: {
    [key: string]: ConfigField;
  } = config.Checklist.PersonalInfo.Page6;
  const visible: Visible = {
    hasEnglishTest: hasEnglishTestConfig?.visible,
    englishTestType: englishTestTypeConfig?.visible && hasEnglishTest === true,
    englishTestTypeOther: englishTestTypeOtherConfig?.visible && englishTestType === 'Other',
    englishTestNotReqdReason: englishTestNotReqdReasonConfig?.visible && hasEnglishTest === false,
    englishTestNotReqdReasonOther:
      englishTestNotReqdReasonOtherConfig?.visible && hasEnglishTest === false && englishTestNotReqdReason === 'Other',
    qualification:
      qualificationConfig?.visible && hasEnglishTest === false && englishTestNotReqdReason === 'Previous test',
    qualificationOther: qualificationConfig?.visible && qualification === 'Other'
  };

  // prettier-ignore
  const complete = (() => {
    if (englishTestType && hasEnglishTest) {
      if (englishTestType !== 'Other') return true;
      return englishTestTypeOther !== '';
    }
    if (englishTestNotReqdReason && !hasEnglishTest) {
      if (englishTestNotReqdReason !== 'Other' && englishTestNotReqdReason !== 'Previous test') return true;
      if (englishTestNotReqdReason === 'Other') return englishTestNotReqdReasonOther !== '';
      if (englishTestNotReqdReason === 'Previous test') {
        if(qualification) {
          if (qualification !== 'Other') return true;
          return qualificationOther !== '';
        }
      }
    }
    return false;
  })();
  return {
    complete,
    visible
  };
}
